import React, { useContext, useState, useEffect } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { validatePlanNameAction } from 'src/redux/actions/planAction'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { PlanAmountModal } from './plans-redux-modal/PlanTimeLine'
import { ToastContainer, toast } from 'react-toastify'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'

import 'react-toastify/dist/ReactToastify.css'
const PlanName = () => {
  useEffect(() => {
    dispatch(action(PlanTypes._CLEAR_PLAN_FORM))
  }, [])
  const [planData, setPlanData] = useState({
    plan_name: '',
    plan_type: 'general',
  })
  const payload = {
    planName: {
      ...planData,
    },
  }
  const [showModal, setShowModal] = useState(false)
  const createPlan = (e: any) => {
    e.preventDefault()
    if (!plan_name) {
      toast.warn('Plan Name can not be empty!', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    validatePlanName()
  }
  const validatePlanName = () => {
    dispatch(validatePlanNameAction({ payload, onSuccess, onError }))
  }

  const onSuccess = (msg: any) => {
    setShowModal(true)
  }

  const onError = (error: any) => {
    toast.error('The plan name has already been taken.', {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
  }
  const dispatch = useDispatch()
  const { plan_name } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  const Disabled = () => {
    if (!plan_name) {
      return 'blur'
    }
    return null
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Goal</ModalTitleText>
          <p className="desc">What do you want to save towards?</p>
          <QuicksaveInput
            type="text"
            name="plan_name"
            value={plan_name}
            placeholder="e.g vacation"
            onChange={handleChange}
          />
        </div>
        <PlanAmountModal showModal={showModal} setShowModal={setShowModal} />
        <div>
          <ModalButton onClick={createPlan} className={`button ${Disabled()}`}>
            Continue
          </ModalButton>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanName }
